import EquipmentWidgetPanel from './equipment-widget-panel';
import styles from '../../add-equipment-widget/add-equipment-widget.module.scss';
import { selectEquipment } from 'services/equipment/actions';
import { useFeedback } from 'providers/feedback-provider';

const MyEquipmentWidget = ({
  showNotifyDealer,
  watchSelectedEquipment,
  showAddEquipmentToast,
  formLocation
}) => {
  const { dismissFeedback } = useFeedback();

  const handleYesClickedDuplicateBanner = () => {
    dismissFeedback();
    showAddEquipmentToast(watchSelectedEquipment);
    if (watchSelectedEquipment != null) {
      selectEquipment(
        watchSelectedEquipment.productId,
        watchSelectedEquipment?.serialNo
      );
    }
  };

  return (
    <div className={`${styles['add-equipment__body']} col`}>
      <EquipmentWidgetPanel
        handleYesClickedDuplicateBanner={handleYesClickedDuplicateBanner}
        showNotifyDealer={showNotifyDealer}
        showFootNote={false}
        formLocation={formLocation}
      />
    </div>
  );
};

export default MyEquipmentWidget;
